import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          sessionExpired: {
            TITLE: 'Your online session will expire in',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          sessionExpired: {
            TITLE: 'Phiên làm việc của bạn sẽ hết hạn trong',
          },
        },
      },
    },
  }),
)
